<template>
  <a-card title="水质监测" :bordered="false" class="water-quality-card">
    <template slot="extra">
      <div class="search-wrapper">
        <div class="search-item">
          <span class="label">监测点：</span>
          <a-select v-model="queryParams.point" placeholder="请选择" style="width: 160px">
            <a-select-option value="1">1#原水水质检测仪</a-select-option>
            <a-select-option value="2">2#出水水质检测仪</a-select-option>
          </a-select>
        </div>
        <div class="search-item">
          <span class="label">指标：</span>
          <a-select v-model="queryParams.metric" placeholder="请选择" style="width: 100px">
            <a-select-option value="ph">PH</a-select-option>
            <a-select-option value="turbidity">浊度</a-select-option>
          </a-select>
        </div>
        <div class="search-item">
          <span class="label">查询时间：</span>
          <a-range-picker v-model="queryParams.dateRange" style="width: 240px" />
        </div>
        <a-button type="primary" class="custom-query-btn" @click="handleQuery">查询</a-button>
      </div>
    </template>

    <div class="chart-container">
      <div ref="chartRef" style="width: 100%; height: 320px;"></div>
    </div>
  </a-card>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'WaterQualityMonitoring',
  data () {
    return {
      queryParams: {
        point: '1',
        metric: 'ph',
        dateRange: []
      },
      chart: null
    }
  },
  mounted () {
    this.initChart()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },
  methods: {
    handleQuery () {
      // 模拟查询，重新渲染图表
      this.initChart()
    },
    handleResize () {
      this.chart && this.chart.resize()
    },
    initChart () {
      const chartDom = this.$refs.chartRef
      if (!this.chart) {
        this.chart = echarts.init(chartDom)
      }

      const option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          borderWidth: 0,
          boxShadow: '0 0 10px rgba(0,0,0,0.1)',
          formatter: function (params) {
            const data = params[0]
            return `
              <div style="padding: 8px;">
                <div style="color: #999; margin-bottom: 4px;">1#原水水质检测仪</div>
                <div style="display: flex; align-items: center; justify-content: space-between;">
                  <span style="display: inline-block; width: 8px; height: 8px; border-radius: 50%; background: #00bcd4; margin-right: 8px;"></span>
                  <span style="font-weight: bold; color: #00bcd4; font-size: 16px; margin-right: 16px;">${data.value}</span>
                  <span style="color: #999;">2025.11.28 10:00</span>
                </div>
              </div>
            `
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['00:00', '02:00', '04:00', '06:00', '08:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00', '24:00'],
          axisLine: {
            lineStyle: {
              color: '#eee'
            }
          },
          axisLabel: {
            color: '#999'
          }
        },
        yAxis: {
          type: 'value',
          name: 'PH',
          min: 0,
          max: 10,
          interval: 1,
          splitLine: {
            lineStyle: {
              type: 'solid',
              color: '#f5f5f5'
            }
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#999'
          }
        },
        series: [
          {
            name: '监测值',
            type: 'line',
            smooth: false,
            data: [5.8, 7.2, 5.7, 6.6, 5.8, 8.1, 8.5, 7.1, 5.8, 6.7, 5.9, 5.4, 4.4],
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              color: '#00bcd4'
            },
            lineStyle: {
              width: 2,
              color: '#00bcd4'
            }
          }
        ]
      }

      this.chart.setOption(option)
    }
  }
}
</script>

<style lang="less" scoped>
.water-quality-card {
  .search-wrapper {
    display: flex;
    align-items: center;

    .search-item {
      display: flex;
      align-items: center;
      margin-right: 20px;

      .label {
        white-space: nowrap;
        color: #666;
        margin-right: 8px;
      }
    }

    .custom-query-btn {
      border-radius: 0;
      padding: 0 20px;
      height: 32px;
      background-color: #1890ff;
      border-color: #1890ff;
      font-size: 14px;
    }

    /deep/ .ant-select-selection--single,
    /deep/ .ant-input {
      height: 32px !important;
      line-height: 32px !important;
      border-radius: 0 !important;
    }

    /deep/ .ant-select-selection__rendered {
      line-height: 30px !important;
    }

    /deep/ .ant-calendar-picker-input {
      height: 32px !important;
      display: flex;
      align-items: center;
    }
  }

  .chart-container {
    height: 100%;
  }
}
</style>
